export default __webpack_public_path__ + "static/media/ofcmarioliveira.c625598d.jpg";